import {
  ObservationsQueryParams,
  ObservationMetricsParams,
  ObservationMetricsResponse
} from '../api/observations-api.interface';
import { ObservationMetrics } from '@model/observation/observation-metrics.model';

export function mapMetricsResponse(
  response: ObservationMetricsResponse
): ObservationMetrics {
  return {
    totalGeneral: response.totalGeneral,
    totalDelDia: response.totalDelDia,
    reportado: response.reportado,
    enGestion: response.enGestion,
    solucionado: response.solucionado
  };
}

export function buildMetricsQueryParams(
  params?: ObservationMetricsParams
): string {
  if (!params) {
    return '';
  }

  const queryParts: string[] = [];
  addFilterParams(queryParts, params);

  return queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
}

export function buildObservationsQueryParams(
  params?: ObservationsQueryParams,
  excludePagination = false
): string {
  if (!params) {
    return '';
  }

  const queryParts: string[] = [];

  if (!excludePagination) {
    addPaginationParams(queryParts, params);
  }
  addSortAndSearchParams(queryParts, params);
  addFilterParams(queryParts, params);

  return queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
}

function addPaginationParams(
  queryParts: string[],
  params: ObservationsQueryParams
): void {
  if (params.page !== undefined) {
    queryParts.push(`page=${params.page}`);
  }
  if (params.size !== undefined) {
    queryParts.push(`size=${params.size}`);
  }
}

function addSortAndSearchParams(
  queryParts: string[],
  params: ObservationsQueryParams
): void {
  if (params.sortBy) {
    queryParts.push(`sortBy=${params.sortBy}`);
  }
  if (params.sortDirection) {
    queryParts.push(`sortDirection=${params.sortDirection}`);
  }
  if (params.searchField && params.searchValue) {
    queryParts.push(`searchField=${params.searchField}`);
    queryParts.push(`searchValue=${encodeURIComponent(params.searchValue)}`);
  }
}

function addFilterParams(
  queryParts: string[],
  params: ObservationsQueryParams | ObservationMetricsParams
): void {
  if (params.statusIds && params.statusIds.length > 0) {
    params.statusIds.forEach((id) => queryParts.push(`statusIds=${id}`));
  }
  if (params.causeIds && params.causeIds.length > 0) {
    params.causeIds.forEach((id) => queryParts.push(`causeIds=${id}`));
  }
  if (params.startDate) {
    queryParts.push(`startDate=${params.startDate}`);
  }
  if (params.endDate) {
    queryParts.push(`endDate=${params.endDate}`);
  }
}
